<template lang="pug">
section.mg-section.mg-intro
  h1.mg-title {{ $t('game.title') }}
  .mg-intro__lead
    p {{ getText }}
    p {{ $t('game.text.description') }}

</template>

<script>
import "@/assets/intro/styles/intro.styl";

import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapState, mapGetters } = createNamespacedHelpers(mg_global);

import FormatDate from "@chronos/frontend-base/src/libs/tools/FormatDate";

export default {
  name: "Intro",

  computed: {
    ...mapState([
      "starts_at",
      "ends_at",
      "current_time",
      "deposit_step",
      "deposit_min_cards_amount",
      "deposit_max_cards_amount",
    ]),
    ...mapGetters(["getActivityType"]),

    getText() {
      let text = "";
      let start = this.getFormatDate(this.starts_at);
      let finish = this.getFormatDate(this.ends_at);

      text = this.$t(`game.text.${this.getActivityType}`, {
        start: start,
        finish: finish,
        min: this.deposit_min_cards_amount,
        max: this.deposit_max_cards_amount,
        step: this.deposit_step,
      });
      return text;
    },
  },

  methods: {
    getFormatDate(timestamp) {
      return FormatDate.convertToDate(timestamp, date => {
        let day = this.addZero(date.getDate());
        let month = this.addZero(date.getMonth() + 1);
        let hours = this.addZero(date.getHours());
        let minutes = this.addZero(date.getMinutes());

        return `${day}.${month} ${hours}:${minutes}`;
      });
    },

    addZero(number) {
      return number < 10 ? "0" + number : number;
    },
  },
};
</script>
